module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step3_Image6.06cb76a8.webp";